import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Button from '@fountain/ui-kit/components/button';

import './styles.pcss';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
const defaultProps = {
  className: undefined,
  children: null,
};

export default function LayoutHeaderButton({ className, children, ...props }) {
  return (
    <Button
      className={cn(className, 'layout-header__button')}
      size={undefined}
      theme="text"
      {...props}
    >
      {children}
    </Button>
  );
}

LayoutHeaderButton.propTypes = propTypes;
LayoutHeaderButton.defaultProps = defaultProps;
